<template>
    <div class="modal fade match-reminder-modal deposit-edit-stake-modal-box" id="singlestakeeditModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                     <h2 class="stake_title_head">{{ $t('edit-stake', 'Edit Stakes') }}</h2>
                </div>
                 <div class="settings-stakes-list diposit_wallet_modal_body">
                    <div class="edit-stack-details diposit_wallet_modal_body">
                        <div class="stakes-bx">
                            <div class="stack-page-container">
                                <ul class="cmn-ul-list">
                                    <li class="w-25" v-for="i in 4">
                                        <input type="text" maxlength="8" v-model="stake[i-1]" @input="stake[i-1] = $helper.sanitizeNumber(stake[i-1], 10000000)" class="btn-thm form-control">
                                    </li>
                                </ul>
                            </div>
                            <div class="edit-save-btn edit_stake_cmn_btn12">                            
                                <button type="button" @click="resetChips()" class="btn cmn-btn cancel_cmn_btn12" data-bs-dismiss="modal">{{$t('cancel','Cancel')}}</button>
                                <button type="button" @click="callChangeStakeValue()" class="btn cmn-btn">{{ $t('save', 'Save') }}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

 
<script>
export default {
    name: "StackModal",
    props: ['stakes'],
    data() {
        return {
            stake: this.$store.getters.userTransactionStakes || this.stakes

        }
    },
    mounted() {
        this.resetChips();
    },
    methods: {
        callChangeStakeValue() {
            if(Object.values(this.stake).some(item => item == '') || Object.values(this.stake).some(item => item < 100)){
                this.$errorToast(this.$t('stake-atleast-100','Stake Value Must be Between 100 to 1cr'));
                return

            }
            this.$store.dispatch('setUserTransactionStakes', JSON.parse(JSON.stringify(this.stake)));
            this.$successToast('Saved Successfully')
            this.$helper.closeModal('singlestakeeditModal');
        },
        resetChips(){
            this.stake = JSON.parse(JSON.stringify(this.$store.getters.userTransactionStakes || this.stakes));
        }
    }
};
</script>